/**
 * ag-grid Filter definitions for TL.
 * @return {object} - Column Filter Config Object
 */

export const trackingTLQueueFilterDefs = [
  {
    type: 'select',
    fieldId: 'Status',
    label: 'Status',
  },
  {
    type: 'type-ahead',
    fieldId: 'OriginCity',
    label: 'Origin City',
  },
  {
    type: 'type-ahead',
    fieldId: 'OriginState',
    label: 'Origin State',
  },
  {
    type: 'date',
    fieldId: 'OriginPickupDate',
    label: 'Origin Pickup Date',
  },
  {
    type: 'type-ahead',
    fieldId: 'DestinationCity',
    label: 'Destination City',
  },
  {
    type: 'type-ahead',
    fieldId: 'DestinationState',
    label: 'Destination State',
  },
  {
    type: 'date',
    fieldId: 'DestinationDropOffDate',
    label: 'Destination Drop Off Date',
  },
  {
    type: 'type-ahead',
    fieldId: 'CarrierName',
    label: 'Carrier',
  },
  {
    type: 'type-ahead',
    fieldId: 'CarrierRepName',
    label: 'Carrier Rep',
  },
  {
    type: 'type-ahead',
    fieldId: 'CustomerName',
    label: 'Customer',
  },
  {
    type: 'date',
    fieldId: 'LastHumanTrackDate',
    label: 'Last Human Update',
  },
  {
    type: 'select',
    fieldId: 'VisibilityAppStatus',
    label: 'Visibility App',
  },
  {
    type: 'select',
    fieldId: 'Problems',
    label: 'Problems',
  },
];

/**
 * ag-grid Filter definitions for LTL.
 * @return {object} - Column Filter Config Object
 */
export const trackingLTLQueueFilterDefs = [
  {
    type: 'select',
    fieldId: 'Status',
    label: 'Status',
  },
  {
    type: 'date',
    fieldId: 'LastHumanTrackDate',
    label: 'Last Human Update',
  },
  {
    type: 'type-ahead',
    fieldId: 'Shipper',
    label: 'Shipper',
  },
  {
    type: 'type-ahead',
    fieldId: 'OriginCity',
    label: 'Origin City',
  },
  {
    type: 'type-ahead',
    fieldId: 'OriginState',
    label: 'Origin State',
  },
  {
    type: 'date',
    fieldId: 'OriginPickupDate',
    label: 'Origin Pickup Date',
  },
  {
    type: 'type-ahead',
    fieldId: 'Consignee',
    label: 'Consignee',
  },
  {
    type: 'type-ahead',
    fieldId: 'DestinationCity',
    label: 'Destination City',
  },
  {
    type: 'type-ahead',
    fieldId: 'DestinationState',
    label: 'Destination State',
  },
  {
    type: 'date',
    fieldId: 'DestinationDropOffDate',
    label: 'Destination Drop Off Date',
  },
  {
    type: 'type-ahead',
    fieldId: 'CustomerName',
    label: 'Customer',
  },
  {
    type: 'type-ahead',
    fieldId: 'CarrierName',
    label: 'Carrier',
  },
  {
    type: 'select',
    fieldId: 'Problems',
    label: 'Problems',
  },
  {
    type: 'type-ahead',
    fieldId: 'SalesRep',
    label: 'Sales Rep',
  },
];
